import type { DebugSectionConfig } from '@hexa/app/debug/DebugPlugin';
import { DebugSectionId } from '@hexa/app/debug/DebugSectionId';
import type { PlatformCheatOptions } from '@hexa/app/platform/Platform';

export class WebCheatOptions implements PlatformCheatOptions {
  public cheatOptions(): DebugSectionConfig[] {
    return [
      {
        id: DebugSectionId.PlatformCheat,
        title: 'Web Cheats',
        expanded: false,
        fields: {},
      },
    ];
  }
}
